import { COLUMN_CATEGORY, COLUMN_CLOSEST_EXPIRY_DAYS, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME,  COLUMN_ENABLED,  COLUMN_EXPIRY_DATE,  COLUMN_EXPIRY_REASON,  COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SECOND_NAME, COLUMN_SITE, COLUMN_START_DATE, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER } from "@/constants/column-types";
import { TableColumn } from "../table/TableColumn";
import { FILTER_COMPANIES, FILTER_STATUS, FILTER_DEPARTMENTS, FILTER_EXPIRY_REASONS, FILTER_PROFILE, FILTER_SITES, FILTER_TAGHOLDERS } from "@/constants/filter-types";
import { ColumnFormattingClasses } from "./constants/ColumnFormattingClasses";

export const OperationalComplianceReportColumns : TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        sortByName: "mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 3,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        isNumeric: true,
        id: 4,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 6,
        active: true,
        searchOnName: "departmentId",
        lookupName: "department",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 7,
        searchOnName: "companyId",
        lookupName: "company",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 8,
        sortByName: "profileName",
        sortDirection: "asc",
        active: false,
        translationKey: "category",
        searchOnName: "profileId",
        lookupName: "profileId",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,
        settingDataName: "profile",
    },
    {
        heading: "Enabled Credentials",
        accessor: "enableCredentialLabel",
        isNumeric: false,
        id: 9,
        sortByName: "mstCurrent",
        active: false,
        translationKey: "enableCredentials",
        columnId: COLUMN_ENABLED,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 10,
        searchOnName: "siteId",
        lookupName: "site",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Days Remaining (closest)",
        accessor: "closestExpiryDays",
        isNumeric: false,
        id: 11,
        active: true,
        translationKey: "daysRemaining",
        columnId: COLUMN_CLOSEST_EXPIRY_DAYS
    },

    {
        heading: "Compliance Condition",
        accessor: "expiryReason",
        id: 12,
        active: false,
        isNumeric: false,
        searchOnName: "expiryReasonId",
        translationKey: "complianceCondition",
        columnId: COLUMN_EXPIRY_REASON,
        filterId: FILTER_EXPIRY_REASONS,
        settingDataName: "expiryReason",
        isFilterOnlyColumn: true
    },
    {
        heading: "Status",
        accessor: "overallStatus",
        isNumeric: false,
        id: 13,
        active: false,
        translationKey: "status",
        searchOnName: "status",
        lookupName: "status",
        filterId: FILTER_STATUS,
        isFilterOnlyColumn: true,
    }
];

export const OperationalComplianceReportChildColumns: TableColumn[] = [
    {
        heading: "Compliance Condition",
        accessor: "expiryReason",
        id: 0,
        active: true,
        isNumeric: false,
        translationKey: "complianceCondition",
        columnId: COLUMN_EXPIRY_REASON,
    },
    {
        heading: "Start Date",
        accessor: "startDate",
        id: 1,
        isNumeric: false,
        active: true,
        translationKey: "startDate",
        columnId: COLUMN_START_DATE
    },
    {
        heading: "Expiry Date",
        accessor: "endDate",
        id: 2,
        active: true,
        isNumeric: false,
        translationKey: "expiryDate",
        columnId: COLUMN_EXPIRY_DATE
    },
    {
        heading: "Days Remaining",
        accessor: "daysRemaining",
        isNumeric: true,
        id: 3,
        active: true,
        translationKey: "daysRemaining",
    },
    {
        heading: "Status",
        accessor: "status",
        id: 4,
        active: true,
        isNumeric: false,
        translationKey: "status",
        valueFormatting: (value) => {
            const valueByStatus = {
                COMPLIANT: ColumnFormattingClasses.categoryGreen,
                WARNING: ColumnFormattingClasses.categoryBlue,
                EXPIRED: ColumnFormattingClasses.categoryRed,
                Compliant: ColumnFormattingClasses.categoryGreen,
                Warning: ColumnFormattingClasses.categoryBlue,
                Expired: ColumnFormattingClasses.categoryRed,
            };

            return valueByStatus[value] ?? "";
        }
    }
];